export default __webpack_public_path__ + "static/media/ainola_1.e4450459.jpg";